// ─────────────────────────────────────────────────────────────────────────────
// SHARED: Auth session  (Firebase Auth state, used by every feature)
// Reads the AuthContext; throws if used outside <AuthProvider>.
// ─────────────────────────────────────────────────────────────────────────────
import { useContext } from "react";
import { AuthContext, type AuthContextValue } from "../utils/authContext";

export default function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth must be used inside <AuthProvider>");
  return context;
}
